import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CloseModalButton = ({ onCloseModal }) => (
  <FontAwesomeIcon icon={faTimes} onClick={onCloseModal} className="selectable" />
);

export default CloseModalButton;
